<template>
  <v-container fluid tag="section">
    <base-material-table
      outlined
      :item="item"
      ref="table"
      @on-add='add'
      single-expand
      row-click
    >
    <template v-slot:condition>
      <v-col cols="12" md='2' class="pr-2 pl-0 pt-c-10">
        <base-marerial-user-select hide-details outlined dense label='创建人' v-model="item.params.uids" :menu='$constants.SysMenu.NOTICE_M_ID'></base-marerial-user-select>
      </v-col>
    </template>
    <template v-slot:expanded-content="{ headers, item, refresh }">
       <td :colspan="headers.length" v-if='refresh' class="px-0">
          <v-divider v-if="$isMobile"></v-divider>
          <detail-view mini :item='item'></detail-view>
      </td>
      </template>
    </base-material-table>
    <add-view :item='addModal' @on-load-data='loadData'></add-view>
  </v-container>
</template>

<script>
  import AddView from './components/Add'
  import DetailView from './components/Detail'

  export default {
    name: 'NoticeIndex',
    components: {
      AddView,
      DetailView
    },
    data() {
      return {
        tab: 0,
        loading: false,
        addModal: { show: false, data: {} },
        item: {
          mobile: true,
          path: 'notice/info/list',
          topButtons: [
            { event: 'search', show: true },
            { event: 'add', show: this.$_has('dashboard-notice-add') }
          ],
          params: {
            uids: []
          },
          headers: [
            {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              mobile: true,
              sortable: false,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.table.showMore(row, idx)
                }
              }
            },
            {
              text: '公告标题',
              align: 'center',
              divider: true,
              value: 'title',
              width: 190,
              sortable: false,
              mobile: true,
              search: { type: 'input', mobile: true, }
            },
            {
              text: '公告类型',
              align: 'center',
              divider: true,
              value: 'type',
              width: 90,
              sortable: false,
              mobile: true,
              chip: {
                color: (val) => (val === 1 ? 'primary' : 'red'),
                formatter: (val) => (val === 1 ? '通知' : '通报')
              }
            },
            {
              text: '内容',
              align: 'center',
              divider: true,
              width: 250,
              value: 'content',
              mobile: true,
              sortable: false,
            },
            {
              text: '通知人数',
              align: 'center',
              divider: true,
              width: 100,
              mobile: true,
              value: 'userIds',
              sortable: false,
              formatter: (val) => JSON.parse(val).indexOf(-1) === 0 ? '全员' : `${JSON.parse(val).length}人`
            },
            {
              text: '已读人数',
              align: 'center',
              divider: true,
              width: 100,
              mobile: true,
              value: 'reads',
              sortable: false,
              formatter: (val) => `${val.length}人`
            },
            {
              text: '未读人数',
              align: 'center',
              divider: true,
              width: 100,
              mobile: true,
              value: 'unReadUsers',
              sortable: false,
              formatter: (val) => `${val.length}人`
            },
            {
              text: '状态',
              align: 'center',
              divider: true,
              width: 100,
              value: 'deleteFlag',
              sortable: false,
              chip: {
                color: (val) => (val === 1 ? 'primary' : 'grey'),
                formatter: (val) => (val === 1 ? '正常' : '作废')
              }
            },
            {
              text: '创建时间',
              align: 'center',
              width: 180,
              value: 'createTime',
              sortable: false,
              divider: true,
              mobile: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD HH:mm')
            },
            {
              text: '创建人',
              align: 'center',
              width: 110,
              value: 'createUser.name',
              sortable: false
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              divider: true,
              sortable: false,
              mobile: true,
              width: 100,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              actions: [
                {
                  text: '删除',
                  color: 'warning',
                  icon: 'mdi-arrow-expand-vertical',
                  onClick: (row, btn) => this.$refs.table.doDelete(row, btn),
                  disable: (row) => row.deleteFlag === 0 || !this.$_has('dashboard-notice-add')
                }
              ]
            }
          ]
        }
      }
    },
    methods: {
      add () {
        this.addModal = { show: true }
      },
      loadData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style>
</style>
